import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconMagnifyGraph = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path stroke="currentColor" strokeWidth={1.5} d="m4 20 5-10 11-4" />
    <circle cx={4} cy={20} r={2} fill="currentColor" />
    <circle cx={8.5} cy={10.5} r={2.5} fill="currentColor" />
    <circle cx={20} cy={6} r={2} fill="currentColor" />
    <path
      fill="currentColor"
      d="M15.884 15.116 15 14.232 13.232 16l.884.884zm1.232 4.768a1.25 1.25 0 0 0 1.768-1.768zM15 16l-.884.884 3 3L18 19l.884-.884-3-3z"
    />
    <circle cx={9.5} cy={10.5} r={6.5} stroke="currentColor" strokeWidth={1.5} />
  </NcIcon>
);
export { NcIconMagnifyGraph };
